export default {
      id: "nav_play-usage",
      viewBox: "0 0 12 12",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#nav_play-usage",
      toString: function () {
        return this.url;
      }
    }